var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 25,
    height: 25,
    fill: "url(#pattern0_23_298)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_23_298",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_23_298",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_23_298",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACxklEQVR4nO2cS4sTQRSFCxeKKK4V3flYDJi6cXAcXQg+fo4jREVTp4X8hRkVfP0WETfqTlfq2hFECKlqE0lctZSrEUxPyHT61nTOB3cXku4vJ6dvIGljCCGEEEIIIYQQQsg/eGevBcgLD/s5QEYBUuy7ceI95MnXzvrh5N7ekK2eDk5eqUtCdeMhz0xK5Jlc8bB9bTGh8mTbX0XPHDCpJLmRkpGa6IbVRdgx3tmnJgV81rquLSMsZgYe9lEyF8O4XUxJwtg72xndu3hc+xgbgXfyZYrojvaxNYrgZPg/0UxyxUzrOIqumKlX66x1p+rXWmpK1qJxlD3C6gntY2wECaxhRc0z8pD3OeR2sXHmEEWjDun2Y//++VNMNOqRXUuyE/goF+rj2hsUjcWL9s6+o2jUkWgZUjTqqQ+KBkUX6hcxJlrUxbE6oC+VHQ2KVk9cYKJFXRKrA/oC2dFIa/iFBRRdaKeQiYa+OFYH9KWyo0HRyY93dhxgNwPs2ve7rSNx8m7rknd2y0MmTDQqEb09cO3WtBVt8EBsfAyrA3tLcpnknbLLks09GrvJtpuzSoo/46VozJtquzar6BwX1ika84n+0Vs5Oqvo+FiKxuJF93trxygarI7Ut46tWRPtnTxmojGnaMgkrm67SoYV7+Q3RWNPyd4ukx0lByffyp7DLBrtj36oqkIgk7gnxxUuXiDj5N325VgXZUmmaNT7RjHRoOhCuy6YaOiLY3VAXyo7GhStnrjARIu6JFYH9AWyo5HW8AsLKLrQTuH+SvSUG6Ms2xitW/0s25hFE5x9qX2SYSlEZ3JT+ySD/vxcuOi/sp19k8DJFo3+030k77bOxRvyaZ9wUBt7y9TFIGtfXUrZTj4UvZWDpk7yh3I2OHm9TJL7sCeNFt61bwQnz72znxq3ZzsZeti3sS5qTzIhhBBCCCGEEEKISZM/8He0cs+WUegAAAAASUVORK5CYII="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.2128c1d7d6450bad3ec8a56f236be213.svg";
export { ForwardRef as ReactComponent };